import { Injectable } from '@angular/core';
import { IModalOptions } from '../../common/modals/modal-options.interface';
import { Observable, of } from 'rxjs';
import { EcaModalOptions } from '../../shared/models/yesno-modal-options.class';
import { OperativeInfo } from '../../domain-model/operative-info.class';
import { OperativeEditorModalComponent } from '../components/operative-editor-modal/operative-editor-modal.component';
import { IJobTitleInfo } from '../../message-models/job-title.interface';
import { IJobLevelInfo } from '../../message-models/job-level.interface';
import { IRiskInfo } from '../../message-models/risk-info.interface';
import { OperativesLeaveConfirmComponent } from '../components/operatives-leave-confirm/operatives-leave-confirm.component';
import { IEmploymentStatus } from '../../message-models/employment-status.interface';
import { EcaDynamicModalService } from "../../shared/services/eca-dynamic-modal-service";
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { IEcaDialogRef } from '../../shared/models/eca-dialog-ref.interface';
import { IOperativeTypeInfo } from '../../message-models/operative-type.interface';
import { IBusinessUnitInfo } from '../../message-models/business-unit.interface';
import { ICompanyJobTitle } from '../../message-models/company-job-title.interface';

@Injectable({
  providedIn: 'root'
})

export class OperativeModalService {
  operativeEditorModalRef: IEcaDialogRef;
  confirmLeaveOperativesModalRef: IEcaDialogRef;

  constructor(private ecaDynamicModalService: EcaDynamicModalService) {
  }

  openOperativeEditorModal(operative?: OperativeInfo,
    headerText?: string,
    allJobTitles: IJobTitleInfo[] = [],
    allCompanyJobTitles: ICompanyJobTitle[] = [],
    allJobLevels: IJobLevelInfo[] = [],
    allRisks: IRiskInfo[] = [], allEmploymentStatuses: IEmploymentStatus[] = [],
    allOperativeTypes: IOperativeTypeInfo[] = [],
    allBusinessUnits: IBusinessUnitInfo[] = [],

    isNewOperative: boolean = false,
    options?: IModalOptions): Observable<IEcaDialogRef> {
    if (options === undefined) {
      options = new EcaModalOptions();
      options.modalClasses += ' modal-eca-success';
    }
    if (!operative) {
      operative = new OperativeInfo();
    }
    let config = {
      styleClass: 'modal-xl ' + options.modalClasses,
      baseZIndex: 2000,
      showHeader: false,
      data: {
        heading: headerText,
        operative,
        allJobTitles,
        allCompanyJobTitles,
        allJobLevels,
        allOperativeTypes,
        allRisks,
        isNewOperative,
        allEmploymentStatuses,
        allBusinessUnits
      }
    } as DynamicDialogConfig;

    this.operativeEditorModalRef = this.ecaDynamicModalService.openDialog(OperativeEditorModalComponent, config);
    return of(this.operativeEditorModalRef);
  }


  openConfirmLeaveOperativesModal(headerText: string,
    options?: IModalOptions): Observable<IEcaDialogRef> {
    if (options === undefined) {
      options = new EcaModalOptions();
      options.modalClasses += ' modal-eca-success';
    }
    let config = {
      styleClass: 'modal-xl ' + options.modalClasses,
      baseZIndex: 2000,
      showHeader: false,
      data: {
        heading: headerText
      }
    } as DynamicDialogConfig;

    this.confirmLeaveOperativesModalRef = this.ecaDynamicModalService.openDialog(OperativesLeaveConfirmComponent, config);

    return of(this.confirmLeaveOperativesModalRef);
  }
}
